import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BaseCta } from './BaseCta';

export const SignUpCta = ({ className }) => (
  <BaseCta className={classNames(className, 'bt--primary bt--outline')} href="/settings/plans?ref=web_studio_detail">
    <FormattedMessage id="schedule.cta.signup" defaultMessage="Sign up" />
  </BaseCta>
);

SignUpCta.propTypes = {
  className: PropTypes.string,
};
